import { TreeItem } from "../components/TreeView/types";
import { ChildrenProductAttribute, ProductAttribute } from "./types";

const transformChildAttributeToTreeViewItem = (
  childrenAttribute: ChildrenProductAttribute | ProductAttribute
): TreeItem => {
  return {
    id: childrenAttribute.id.toString(),
    label: childrenAttribute.name,
    meta: childrenAttribute.description,
  };
};

export const transformAttributeToTreeViewItem = (
  attribute: ProductAttribute
): TreeItem => {
  return {
    ...transformChildAttributeToTreeViewItem(attribute),
    children: attribute.childrenAttributes.map(
      transformChildAttributeToTreeViewItem
    ),
  };
};
